'use client'
import { useEffect, useMemo } from 'react'
import branch from 'branch-sdk'
import { useUserContext } from './UserContext'
import { storageMode } from '../helpers'
import { claimUserCredit } from '../services'

const key = process.env.NEXT_PUBLIC_BRANCH_KEY

const BranchWrapper = () => {
  const { user } = useUserContext()
  const storage = useMemo(() => storageMode('localStorage'), [])

  const saveCode = async (userId, code) => {
    try {
      await claimUserCredit(userId, code)
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    branch.init(key, (err, data) => {
      if (err) {
        console.log('BRANCH ERR', err)
        return
      }

      // data_parsed comes from a referral link w/
      // associated data
      if (data?.data_parsed) {
        const code = data?.data_parsed?.code

        //handle promo code payload
        if (code) {
          // save diretly to user
          if (user?.id) {
            saveCode(user.id, code)
            return
          }

          // save to check during auth
          storage.setItem('branch_promo_code', code)
        }
      }
    })
  }, [user, storage])

  return null
}

export default BranchWrapper
